import { useUserInfo } from '@/entities/user/api/useUserInfo.ts';
import type { User } from '@/shared/api/experience';

// TODO переделать на сервис пермиссий
export const useUserStore = defineStore('listing-user-store', () => {
  const user = ref<Nullable<User>>(null);
  const isAdmin = ref<boolean>(false);

  const getUser = async () => {
    const { data: userData } = await useUserInfo().fetchUser();
    user.value = userData?.user || null;
    isAdmin.value = userData?.user?.user_role?.exp_user_role === 'admin';

    return user.value;
  };

  return {
    user,
    isAdmin,
    getUser,
  };
});
